import { motion } from 'framer-motion'
import styled from 'styled-components/macro'
import { mq } from 'styles/mq'
import { theme } from 'styles/theme'

export const StyledHeader = styled.header`
  width: 100%;
  height: 100vh;
  background: radial-gradient(
    circle at center,
    ${theme.colors.accent.primaryLight},
    ${theme.colors.accent.primary}
  );
`

export const LogoWrapper = styled.div`
  position: sticky;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100vh;
  margin-bottom: -100vh;
  overflow: hidden;
  pointer-events: none;
  z-index: 1;

  ${mq.smallOnly} {
    padding-bottom: 4rem;
  }
`

export const Logo = styled(motion.div)`
  position: relative;

  ${mq.smallOnly} {
    transform: translate(-15%);
  }
`

export const MainImage = styled.img`
  display: block;
  position: relative;
  width: 130%;

  ${mq.medium} {
    max-width: 100%;
  }

  ${mq.large} {
    width: 100rem;
  }
`

export const AbsoluteImage = styled.img`
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 130%;

  ${mq.medium} {
    width: 100%;
  }
`

export const BrightImage = styled(AbsoluteImage)`
  filter: brightness(1.08);
`
